// extracted by mini-css-extract-plugin
module.exports = {"main":"SendFormDialogStyles_main__strVv","buttons":"SendFormDialogStyles_buttons__2pPIn","paddingRight":"SendFormDialogStyles_paddingRight__2x5aC"};